import {useTranslation} from '@wix/yoshi-flow-editor'
import React, {useState} from 'react'
import {Toast, ToastSkin} from 'wix-ui-tpa/cssVars'
import {Plan} from '../plan'
import s from './desktop.scss'
import {Sidebar} from './sidebar'
import {DesktopProps} from './index'

export const Desktop = ({
  onPlaceClick,
  onRemoveClick,
  onCheckoutClick,
  showAccessibilityMode,
  selectSeatForDescription,
}: DesktopProps) => {
  const {t} = useTranslation()
  const [forcedPopover, setForcedPopover] = useState(null as string)
  const [accessibilityToast, setAccessibilityToast] = useState(false)

  return (
    <div className={s.container}>
      <Sidebar
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        setForcedPopover={setForcedPopover}
        selectSeatForDescription={selectSeatForDescription}
        setAccessibilityToast={setAccessibilityToast}
      />
      <div className={s.planContainer}>
        {showAccessibilityMode && accessibilityToast ? (
          <Toast
            className={s.toast}
            skin={ToastSkin.status}
            shouldShowCloseButton
            onClose={() => setAccessibilityToast(false)}
          >
            {t('seatings_accessibility_toast')}
          </Toast>
        ) : null}
        <Plan onPlaceClick={onPlaceClick} forcedPopover={forcedPopover} setAccessibilityToast={setAccessibilityToast} />
      </div>
    </div>
  )
}
